/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsUrlOpenMethodFromJSON, FxIdDomainSettingsUrlOpenMethodToJSON, } from './FxIdDomainSettingsUrlOpenMethod';
import { FxIdDomainSettingsEGameOrientationFromJSON, FxIdDomainSettingsEGameOrientationToJSON, } from './FxIdDomainSettingsEGameOrientation';
import { FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSON, FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptions';
import { FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation';
import { FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions';
import { FxIdDomainSettingsPublicWebClientConfigOptionsFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptions';
import { FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseSupport';
import { FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseAuth';
import { FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions';
import { FxIdDomainEntitiesPlayGameTypeFromJSON, FxIdDomainEntitiesPlayGameTypeToJSON, } from './FxIdDomainEntitiesPlayGameType';
import { FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions';
import { FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSON, FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBasePresentation';
import { FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSON, FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseStatistics';
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBase interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBase(value) {
    if (!('PlayGameType' in value) || value['PlayGameType'] === undefined)
        return false;
    if (!('PlatformData' in value) || value['PlatformData'] === undefined)
        return false;
    if (!('GameOrientation' in value) || value['GameOrientation'] === undefined)
        return false;
    if (!('MobileGameOrientation' in value) || value['MobileGameOrientation'] === undefined)
        return false;
    if (!('SupportedLanguages' in value) || value['SupportedLanguages'] === undefined)
        return false;
    if (!('DefaultLanguage' in value) || value['DefaultLanguage'] === undefined)
        return false;
    if (!('Store' in value) || value['Store'] === undefined)
        return false;
    if (!('Turnstile' in value) || value['Turnstile'] === undefined)
        return false;
    if (!('CompanyName' in value) || value['CompanyName'] === undefined)
        return false;
    if (!('TosUrl' in value) || value['TosUrl'] === undefined)
        return false;
    if (!('TosUrlOpenMethod' in value) || value['TosUrlOpenMethod'] === undefined)
        return false;
    if (!('PpUrl' in value) || value['PpUrl'] === undefined)
        return false;
    if (!('PpUrlOpenMethod' in value) || value['PpUrlOpenMethod'] === undefined)
        return false;
    if (!('PublicWebClientConfig' in value) || value['PublicWebClientConfig'] === undefined)
        return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    if (!('NamespacedProductsL10N' in value) || value['NamespacedProductsL10N'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PlayGameType': FxIdDomainEntitiesPlayGameTypeFromJSON(json['PlayGameType']),
        'PlatformData': FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSON(json['PlatformData']),
        'Statistics': json['Statistics'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSON(json['Statistics']),
        'GameOrientation': FxIdDomainSettingsEGameOrientationFromJSON(json['GameOrientation']),
        'MobileGameOrientation': FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSON(json['MobileGameOrientation']),
        'Presentation': json['Presentation'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSON(json['Presentation']),
        'MobilePresentation': json['MobilePresentation'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSON(json['MobilePresentation']),
        'ViewportPresentation': json['ViewportPresentation'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSON(json['ViewportPresentation']),
        'SupportedLanguages': json['SupportedLanguages'],
        'DefaultLanguage': json['DefaultLanguage'],
        'Support': json['Support'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSON(json['Support']),
        'Store': FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSON(json['Store']),
        'FxLauncherOptions': json['FxLauncherOptions'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSON(json['FxLauncherOptions']),
        'Turnstile': FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSON(json['Turnstile']),
        'CompanyName': json['CompanyName'],
        'TosUrl': json['TosUrl'],
        'TosUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodFromJSON(json['TosUrlOpenMethod']),
        'PpUrl': json['PpUrl'],
        'PpUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodFromJSON(json['PpUrlOpenMethod']),
        'PublicWebClientConfig': FxIdDomainSettingsPublicWebClientConfigOptionsFromJSON(json['PublicWebClientConfig']),
        'Auth': json['Auth'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSON(json['Auth']),
        'GameSystemName': json['GameSystemName'],
        'NamespacedProductsL10N': json['NamespacedProductsL10N'],
        'ProductL10NNamespace': json['ProductL10NNamespace'] == null ? undefined : json['ProductL10NNamespace'],
    };
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PlayGameType': FxIdDomainEntitiesPlayGameTypeToJSON(value['PlayGameType']),
        'PlatformData': FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSON(value['PlatformData']),
        'Statistics': FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSON(value['Statistics']),
        'GameOrientation': FxIdDomainSettingsEGameOrientationToJSON(value['GameOrientation']),
        'MobileGameOrientation': FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSON(value['MobileGameOrientation']),
        'Presentation': FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSON(value['Presentation']),
        'MobilePresentation': FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSON(value['MobilePresentation']),
        'ViewportPresentation': FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSON(value['ViewportPresentation']),
        'SupportedLanguages': value['SupportedLanguages'],
        'DefaultLanguage': value['DefaultLanguage'],
        'Support': FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSON(value['Support']),
        'Store': FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSON(value['Store']),
        'FxLauncherOptions': FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSON(value['FxLauncherOptions']),
        'Turnstile': FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSON(value['Turnstile']),
        'CompanyName': value['CompanyName'],
        'TosUrl': value['TosUrl'],
        'TosUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodToJSON(value['TosUrlOpenMethod']),
        'PpUrl': value['PpUrl'],
        'PpUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodToJSON(value['PpUrlOpenMethod']),
        'PublicWebClientConfig': FxIdDomainSettingsPublicWebClientConfigOptionsToJSON(value['PublicWebClientConfig']),
        'Auth': FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSON(value['Auth']),
        'GameSystemName': value['GameSystemName'],
        'NamespacedProductsL10N': value['NamespacedProductsL10N'],
        'ProductL10NNamespace': value['ProductL10NNamespace'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBase.js.map